'use client';

import { useSearchParams } from 'next/navigation';
import { isFromGooglePmax } from '@/utils/utm';
import NextImage from 'next/image';
import { Box, Container } from '@skin-seoul/design-system';
const PMaxAdBanner = () => {
  const searchParams = useSearchParams();
  const params = Object.fromEntries(searchParams);
  if (!isFromGooglePmax(params)) {
    return null;
  }
  return <Box width="100%" overflow="hidden" data-sentry-element="Box" data-sentry-component="PMaxAdBanner" data-sentry-source-file="PMaxAdBanner.tsx">
      {/* Mobile banner */}
      <Box display={{
      base: 'block',
      tablet: 'none'
    }} width="100%" data-sentry-element="Box" data-sentry-source-file="PMaxAdBanner.tsx">
        <NextImage src="https://dev-banners.skin-seoul.com/2025-11-15/banner-mob.webp" alt="Authentic K-beauty, Shipped Straight from Seoul" width={640} height={120} style={{
        width: '100%',
        height: 'auto',
        display: 'block'
      }} data-sentry-element="NextImage" data-sentry-source-file="PMaxAdBanner.tsx" />
      </Box>

      {/* Desktop banner */}
      <Box display={{
      base: 'none',
      tablet: 'block'
    }} width="100%" data-sentry-element="Box" data-sentry-source-file="PMaxAdBanner.tsx">
        <Container maxWidth="1280px" padding={0} margin="0 auto" overflow="hidden" data-sentry-element="Container" data-sentry-source-file="PMaxAdBanner.tsx">
          <NextImage src="https://dev-banners.skin-seoul.com/2025-11-15/banner-web.webp" alt="Authentic K-beauty, Shipped Straight from Seoul" width={1280} height={120} style={{
          width: '100%',
          height: 'auto',
          display: 'block'
        }} data-sentry-element="NextImage" data-sentry-source-file="PMaxAdBanner.tsx" />
        </Container>
      </Box>
    </Box>;
};
export default PMaxAdBanner;